import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  
  return (
    <nav className={`navbar ${isHomePage ? '' : 'extended'}`}>
      {!isHomePage && (
        <Link to="/" className="nav-item home-item">
          Home.
        </Link>
      )}
      <Link 
        to="/work" 
        className={`nav-item ${location.pathname === '/work' ? 'active' : ''}`}
      >
        Work.
      </Link>
      <Link 
        to="/writings" 
        className={`nav-item ${location.pathname === '/writings' ? 'active' : ''}`}
      >
        Writings.
      </Link>
      <Link 
        to="/photography" 
        className={`nav-item ${location.pathname === '/photography' ? 'active' : ''}`}
      >
        Photography.
      </Link>
      <Link 
        to="/books" 
        className={`nav-item ${location.pathname === '/books' ? 'active' : ''}`}
      >
        Books.
      </Link>
    </nav>
  );
};

export default Navbar;
